import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useUserPermissionsByEmail } from 'services/user/permissions/permissions-by-email';
import { useModal } from 'store/modals';
import { useUpdateUserPermissions } from 'services/user/update-permissions';
import { Text } from 'components/typography';
import { Button } from 'semantic-ui-react';
import { useFormContext } from 'react-hook-form';
import { UserAdministrationModalContext } from '../../../../../../UserAdministrationModalContext';
import styles from '../../styles.module.scss';

export const ManagePrimaryResidentPermissions = () => {

  const intl = useIntl();

  const {
    selectedUser,
    isPrimaryResidentAddress,
  } = useContext(UserAdministrationModalContext);
  const userPermissionsByEmail = useUserPermissionsByEmail(selectedUser && selectedUser.email);
  const updateUserPermissions = useUpdateUserPermissions({ selectedUser });

  const { watch } = useFormContext();
  const { openModal } = useModal();
  const addressId = watch('addressId');

  const handlePrimaryResidentChange = () => {
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage({ id: 'changePrimaryResidentAddress' }),
        content: intl.formatMessage({
          id: 'changePrimaryResidentAddressContent',
        }, {
          selectedUserEmail: <strong>{selectedUser.email}</strong>,
          aptId: <strong>{addressId}</strong>,
        }),
        onConfirm: async () => {
          await updateUserPermissions.mutateAsync({
            userEmail: selectedUser.email,
            permissions: {
              'admin-address': {
                read: true,
              },
            },
          });
        },
      },
    });
  };

  return (
    <div className={`${styles.service} ${styles.centered}`}>
      {
        isPrimaryResidentAddress && !userPermissionsByEmail.isFetching ? (
          <>
            <Text>
              <FormattedMessage
                id="userIsPrimaryResident"
                values={{ aptId: <strong> {selectedUser.addressId} </strong> }}
              />
            </Text>
            <div />
          </>
        ) : (
          <>
            <Text>
              <FormattedMessage
                id="userIsNotPrimaryResident"
                values={{ aptId: <strong> {selectedUser.addressId} </strong> }}
              />
            </Text>
            <Button
              className={styles.deleteBtn}
              onClick={() => handlePrimaryResidentChange()}
            >{intl.formatMessage({ id: 'reassignPrimaryResident' })}
            </Button>
          </>
        )
      }
    </div>

  );
};
